<template>
    <v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="My Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="mt-4">
            <v-img :src="require('@/assets/banners/jobs-by-category.png')"></v-img>
        </div>
        

        <div class="display-1 text-center bMapCareer--text font-weight-medium mt-8">PROFESSIONS OF THE FUTURE</div>

        <div class="text-center">
            <v-btn text class="accent--text" @click="$router.push('/map-of-careers/jobs-by-category')">
                <v-icon small color="accent" left>fa-angle-left</v-icon>
                Back to menu
            </v-btn>
        </div> 

        <v-divider class="mt-3 mb-6"></v-divider>

         <!-- SHOWING COMBO -->
        <!-- <div class="d-flex justify-center mt-1">
            <div style="max-width:320px">
                <v-select
                    v-model="showingCombo"
                    :items="categories"
                    item-text="text"
                    item-value="id"
                    outlined dense
                    append-icon="fa-angle-down accent--text"
                    label="Selecciona">
                </v-select>
            </div>
        </div> -->

        <div v-if="showingCombo=='us' || showingCombo.id=='us'">
            <v-card outlined v-if="loaded">
                <div class="d-flex justify-space-between body-2 font-weight-medium white--text primary pa-6">
                    <div>Profession of the future</div>
                    <div class="text-right" style="margin-right:80px"># Colleges</div>
                </div>
                <div class="pt-3">
                    <div :class="{'grey lighten-4': index % 2==1}" v-for="(item, index) in items" :key="item.id">
                        <div class="d-flex justify-space-between py-4 px-6">
                            <div class="body-2">{{item.position}}. {{item.name}}</div>
                            <div class="d-flex align-center">
                                <div class="body-2 black--text mr-4">{{item.info.length}}</div>
                                <div>
                                    <v-btn small depressed class="bMapCareer white--text" @click="$router.push('/map-of-careers/jobs-by-category/professions-of-future/'+item.id)">
                                        See more
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                        <v-divider v-if="index<items.length-1"></v-divider>
                    </div>
                </div>
            </v-card>
        </div>

        <div class="text-center mt-4" v-else>
            Soon you will find it here! <v-icon class="ml-2" color="light-blue">fa-smile-wink</v-icon>
        </div>

        <SendingLoader v-if="!loaded" />
    </v-card>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Careers from '@/firebase/careers'

export default {
    data: () => ({
        loaded: false,
        items: [],
        showingCombo: 'us',
        categories: [{id:'us', text:'United States'}, {id:'asia', text:'Asia'}, {id:'europe', text:'Europe'}, {id:'rest', text:'Rest of America'}]
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Careers.getPOFs()
                    .then(response => {
                        if (response.status == true) {
                            this.items = Helpers.formatItems(response.query);
                            this.items = _.sortBy(this.items, 'position');
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>